import Cookies from 'js-cookie'

const TokenKey = 'Authorization'
/*
* 设置setLocalStorage
* */
export function setLocalStorage(key, value) {
    window.localStorage.setItem(key, window.JSON.stringify(value))
}
/*
* 获取getLocalStorage
* */
export function getLocalStorage(key) {
    return window.JSON.parse(window.localStorage.getItem(key) || '[]')
}

// 删除getLocalStorage
export function removeLocalStorage(key) {
    return window.localStorage.removeItem(key)
}

/*
* 设置setSessionStorage
* */
export function setSessionStorage(key, value) {
    window.sessionStorage.setItem(key, window.JSON.stringify(value))
}

/*
* 获取getSessionStorage
* */
export function getSessionStorage(key) {
    return window.JSON.parse(window.sessionStorage.getItem(key) || '[]')
}

/*
* 获取getToken
* */
export function getToken() {
    return Cookies.get(TokenKey)
}

/*
* 设置setToken
* */
export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

/*
* 移除removeToken
* */
export function removeToken() {
    return Cookies.remove(TokenKey)
}

// 手机号码校验
export function MobileVerification(str) {
    let reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
    return reg.test(str);
}

//获取网页链接参数
export function getUrlParam() {
    var url = location.search; //获取url中"?"符后的字串   
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

export function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}